import { ChangeDetectionStrategy, Component, inject } from '@angular/core';

import { ApContentService } from '@ap/content';

import content from './conversational-chat-disclaimer.content.json';

@Component({
    selector: 'conversational-chat-disclaimer',
    templateUrl: './conversational-chat-disclaimer.component.html',
    standalone: false,
    changeDetection: ChangeDetectionStrategy.OnPush
})
export class ConversationalChatDisclaimerComponent {
    private readonly apContentService = inject(ApContentService);

    constructor() {
        this.apContentService.addContentItems(content);
    }
}
